import React from "react";
import { Tabs } from "antd";
import { useHistory, useParams } from "react-router-dom";
import Reports from "./Reports";
import Violations from "./Violations";
import Appeals from "./Appeals";

const { TabPane } = Tabs;

const VALID = ["reports", "violations", "appeals"];

/**
 * Moderation dashboard shell. The active tab is kept in the URL
 * (/moderation/:tab) so links and refreshes land on the right view.
 */
const Moderation = () => {
  const history = useHistory();
  const { tab } = useParams();
  const active = VALID.includes(tab) ? tab : "reports";

  return (
    <div
      style={{
        background: "white",
        border: "1px solid #efefef",
        padding: "16px 16px 24px",
      }}
    >
      <h2 style={{ marginBottom: 8 }}>Moderation</h2>
      <Tabs
        activeKey={active}
        onChange={(k) => history.push(`/moderation/${k}`)}
        destroyInactiveTabPane
      >
        <TabPane tab="Reports" key="reports">
          <Reports />
        </TabPane>
        <TabPane tab="Suspensions" key="violations">
          <Violations />
        </TabPane>
        <TabPane tab="Appeals" key="appeals">
          <Appeals />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Moderation;
